import { Min, Max, IsBoolean, IsOptional } from 'class-validator';

import { TranslationsEnum } from '@onArte/shared/enums/common';
import { RangeModel } from '@onArte/shared/models/common';

export class EventAssignItemModel {
  @Min(1, {
    message: TranslationsEnum.ValidationErrorMin,
    context: {
      min: 1
    }
  })
  @Max(1000000, {
    message: TranslationsEnum.ValidationErrorMax,
    context: {
      max: 1000000
    }
  })
  public startPrice: number;

  @IsOptional()
  public estimation?: RangeModel<number>;

  @Min(1, {
    message: TranslationsEnum.ValidationErrorMin,
    context: {
      min: 1
    }
  })
  @Max(1000000, {
    message: TranslationsEnum.ValidationErrorMax,
    context: {
      max: 1000000
    }
  })
  public acceptablePrice: number;

  @IsBoolean({ message: TranslationsEnum. ValidationErrorIsBoolean })
  public highlighted: boolean;

  constructor(
    startPrice: number,
    estimation: RangeModel<number>,
    acceptablePrice: number,
    highlighted: boolean
  ) {
    this.startPrice = startPrice;
    this.estimation = estimation;
    this.acceptablePrice = acceptablePrice;
    this.highlighted = highlighted;
  }
}
